var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Elevation } from '../../theme/elevation';
import { ThemeFamilies } from '../../theme/families';
import { FontWeights } from '../../theme/typography';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import { Typographies } from '../../utils/getThemeTypography';
import Button from '../Button';
import Icon, { IconName } from '../Icon';
import Typography from '../Typography';
export var BannerVariants;
(function (BannerVariants) {
    BannerVariants["FILLED"] = "filled";
    BannerVariants["FILLED_SHADOW"] = "filled_shadow";
    BannerVariants["OUTLINED"] = "outlined";
    BannerVariants["OUTLINED_SHADOW"] = "outlined_shadow";
})(BannerVariants || (BannerVariants = {}));
var getBannerVariant = function (variant) {
    switch (variant) {
        case BannerVariants.FILLED:
            return FilledBanner;
        case BannerVariants.FILLED_SHADOW:
            return FilledWithShadowBanner;
        case BannerVariants.OUTLINED:
            return BaseBannerWrapper;
        case BannerVariants.OUTLINED_SHADOW:
            return OutlinedShadowBanner;
        default:
            return BaseBannerWrapper;
    }
};
var getThemeFamilyIcon = function (themeFamily) {
    switch (themeFamily) {
        case ThemeFamilies.INFO:
            return IconName.INFO_SQ;
        case ThemeFamilies.ERROR:
            return IconName.DELETE_SQ;
        case ThemeFamilies.SUCCESS:
            return IconName.CHECK_SQ;
        case ThemeFamilies.WARNING:
            return IconName.WARNING;
        default:
            return IconName.INFO_SQ;
    }
};
var Banner = function (_a) {
    var name = _a.name, staticSize = _a.staticSize, variant = _a.variant, title = _a.title, subTitle = _a.subTitle, buttonProps = _a.buttonProps, customIconName = _a.customIconName, themeFamily = _a.themeFamily, className = _a.className;
    var BannerVariant = getBannerVariant(variant);
    var iconName = customIconName || getThemeFamilyIcon(themeFamily);
    return (_jsxs(BannerVariant, __assign({ className: className, staticSize: staticSize, "data-testid": name, themeFamily: themeFamily }, { children: [_jsxs(ContentWrapper, __assign({ "data-testid": name + "-content-wrapper", className: "banner-content-wrapper" }, { children: [_jsx(IconBackground, __assign({ "data-testid": name + "-icon-background", className: "banner-icon-background", staticSize: staticSize }, { children: _jsx(StyledIcon, { name: iconName }, void 0) }), void 0),
                    _jsxs(TextWrapper, { children: [title && (_jsx(TitleWrapper, __assign({ name: name + "-title-wrapper", type: Typographies.BODY2, className: "banner-title-wrapper" }, { children: title }), void 0)),
                            subTitle && (_jsx(SubTitleWrapper, __assign({ name: name + "-subtitle-wrapper", type: Typographies.CAPTION, className: "banner-subtitle-wrapper" }, { children: subTitle }), void 0))] }, void 0)] }), void 0),
            buttonProps && (_jsx(StyledButton, __assign({ themeFamily: themeFamily, staticSize: staticSize, name: name + "-button" }, buttonProps), void 0))] }), void 0));
};
Banner.defaultProps = {
    variant: BannerVariants.OUTLINED,
    themeFamily: ThemeFamilies.INFO,
};
export default Banner;
var IconBackground = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n"], ["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n"])), getThemeBreakpoints('bannerIconBackground'));
var StyledIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var BaseBannerWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"], ["\n  ", "\n\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n\n  ",
    "\n"])), getThemeBreakpoints('banner'), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    var _b = theme.families.banner[themeFamily], main = _b.main, light = _b.light;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border: 1px solid ", ";\n\n      ", " {\n        color: ", ";\n      }\n\n      ", " {\n        background-color: ", ";\n      }\n    "], ["\n      border: 1px solid ", ";\n\n      ", " {\n        color: ", ";\n      }\n\n      ", " {\n        background-color: ", ";\n      }\n    "])), main, StyledIcon, main, IconBackground, light);
});
var BannerWithShadow = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  box-shadow: ", ";\n"], ["\n  box-shadow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.elevation[Elevation.DEPTH10];
});
var OutlinedShadowBanner = styled(BaseBannerWrapper)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), BannerWithShadow);
var FilledBanner = styled(BaseBannerWrapper)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    var light = theme.families.banner[themeFamily].light;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), light);
});
var FilledWithShadowBanner = styled(FilledBanner)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), BannerWithShadow);
var ContentWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  & > *:not(:last-child) {\n    margin-right: 8px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  & > *:not(:last-child) {\n    margin-right: 8px;\n  }\n"])));
var TextWrapper = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  & > *:not(:last-child) {\n    margin-bottom: 4px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  & > *:not(:last-child) {\n    margin-bottom: 4px;\n  }\n"])));
var TitleWrapper = styled(Typography)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-weight: ", ";\n"], ["\n  font-weight: ", ";\n"])), FontWeights.MEDIUM);
var SubTitleWrapper = styled(Typography)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var StyledButton = styled(Button)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
